/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name ActivatedPackages
 */
angular.module('mercury.modules.time.compliance.payrules')
.factory('ActivatedPackages', ["$resource", "settings", function($resource, settings) {
  var PackageActivation = $resource(settings.mercHost + '/pay-rules/packages/activate');
  var PackageActivationById = $resource(settings.mercHost + '/pay-rules/packages/activate/:id', {id: '@id'}, {patch: {method: 'PUT'}});

  function createPackageActivation(activationModel) {
    return PackageActivation.save(activationModel).$promise;
  }

  function updatePackageActivation(activationModel) {
    if (activationModel.validTo === '') {
      activationModel.validTo = null;
    }
    if (activationModel.validFrom === '') {
      activationModel.validFrom = null;
    }
    return PackageActivationById.update(activationModel).$promise;
  }

  return {
    createPackageActivation: createPackageActivation,
    updatePackageActivation: updatePackageActivation
  };
}]);
